import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'shared-confirmation',
    templateUrl: './confirmation.shared.component.html',
    styleUrls: ['./confirmation.shared.component.scss']
})
export class ConfirmationComponent implements OnInit {
    @Input() public type: OLO.Components.HEADER_TYPE = '2';
    @Input() public center: boolean = true;
    @Input() public marginTop: OLO.Components.MARGIN_SIZE = 'lg';
    @Input() public marginBottom: OLO.Components.MARGIN_SIZE = 'lg';

    @Input() public icon: string = 'checkmark';
    @Input() public size: OLO.Components.INDICATOR_SIZE = 'xxxlg';
    @Input() public feel: OLO.Components.INDICATOR_FEEL = 'positive-full';
    @Input() public inverted: boolean = false;

    constructor() { }

    ngOnInit(): void { }
}
